import CheckpointResult from '@/features/evaluationResults/components/CheckpointResult';
import EvaluationSidebar from '@/features/evaluationResults/components/EvaluationSidebar';
import AssessmentDrawer from '../../components/AssessmentDrawer';
import { useSiteEvaluationController } from './useSiteEvaluationController';

// TEMPORARY — Site Compliance bugs belong on the SITECOM Kanban board (Jira project
// SIT). The accountable->board map in Settings already says so, since every Site
// Compliance checkpoint is accountable "Network", but this portal's app registration
// has no consent for the Conformance API that serves GET /system/jira-boards, so the
// map is unreachable from here. Pinning the key both fixes the board and skips that
// failing call. Remove once the Conformance consent lands — see PP-3723.
const SITE_COMPLIANCE_JIRA_PROJECT_KEY = 'SIT';

const SiteEvaluationPage = () => {
  const {
    activeCheckpoint,
    activeView,
    application,
    availableViews,
    emptyStateMessage,
    errorMessage,
    evaluation,
    evaluationId,
    handleBack,
    handleCheckpointSelect,
    handleExportEvaluation,
    handleViewChange,
    isLoading,
  } = useSiteEvaluationController();

  if (isLoading) {
    return (
      <div className="flex min-h-[360px] w-full gap-4">
        <div className="w-96 max-w-full animate-pulse rounded border border-gray-200 bg-gray-100 max-sm:hidden" />
        <div className="flex flex-1 flex-col gap-3">
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={`site-evaluation-skeleton-${index}`}
              className="h-10 animate-pulse rounded bg-gray-100"
            />
          ))}
        </div>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <div className="flex min-h-[240px] w-full items-center justify-center rounded border border-red-200 bg-red-50 px-4 text-center text-sm text-red-700">
        {errorMessage}
      </div>
    );
  }

  if (emptyStateMessage) {
    return (
      <div className="flex min-h-[240px] w-full items-center justify-center rounded border border-gray-200 bg-white px-4 text-center text-sm text-gray-500">
        {emptyStateMessage}
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 -mx-4 -my-4 w-full max-sm:mx-0 max-sm:my-0 max-sm:flex-col max-sm:overflow-x-hidden lg:-mr-8">
      <EvaluationSidebar
        evaluation={evaluation}
        activeCheckpoint={activeCheckpoint}
        onCheckpointClick={handleCheckpointSelect}
        application={application}
        activeView={activeView}
        availableViews={availableViews}
        hideEnvironmentBadge
        showApplicationDetails={false}
        jiraBoardKey={SITE_COMPLIANCE_JIRA_PROJECT_KEY}
        onBackClick={handleBack}
        onViewChange={handleViewChange}
      />
      <div className="min-w-0 flex-1 max-sm:w-full max-sm:flex-none">
        <CheckpointResult
          checkpoint={activeCheckpoint}
          activeView={activeView}
          availableViews={availableViews}
          onExportCsvOverride={handleExportEvaluation}
          exportCsvLabel="Export checkpoints CSV"
          onViewChange={handleViewChange}
          evaluation={evaluation}
          evaluationId={evaluationId}
          bitId={evaluation?.metadata.bitId ?? ''}
          showViewSwitcher={false}
          showAiAnalysis={false}
          reportBugProjectKey={SITE_COMPLIANCE_JIRA_PROJECT_KEY}
          canOpenAssessmentData
          renderAssessmentDataDrawer={(props) => (
            <AssessmentDrawer {...props} title="Checkpoint Assessment Data" />
          )}
        />
      </div>
    </div>
  );
};

export default SiteEvaluationPage;
